import {ExceptionContract} from 'common/exception/ExceptionContract';

export class MainException extends Error implements ExceptionContract {
    public code: number;
    public data: {[key: string]: any};

    public constructor(message: string, code?: number, data?: {[key: string]: any}) {
        super(message);
        this.code = code;
        this.data = data;
        this.name = 'MainException';
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, MainException);
        } else {
            this.stack = (new Error(message)).stack;
        }
    }
}
